import React from 'react'
import { Calendar as ReactCalendar } from 'react-big-calendar'

import CalendarTitle from '../../../components/pages/Register/CreateBanners/components/Step2/CalendarTitle'
import WeekDaysHeader from '../../../components/pages/Register/CreateBanners/components/Step2/WeekDaysHeader'
import FindTutorCalendarViewTimeSlot from './FindTutorCalendarViewTimeSlot'

import { localizer } from '../../../constants'

import './findTutorCalendarView.css'

const FindTutorCalendarView = ({ classBanner, setSelectedSlot, selectedSlot }) => {
  const handleRenderToolbarAfter = () => {
    return (
      <p className="mt-[8px] text-base font-medium text-primary-100">
        The time displayed here is in your local time zone
      </p>
    )
  }

  return (
    <ReactCalendar
      className="find-tutor-calendar metaverse-calendar w-full h-[65vh] max-h-[546px] rounded-[12px] text-primary-100"
      defaultView="week"
      startAccessor="start"
      endAccessor="end"
      localizer={localizer}
      defaultDate={new Date()}
      components={{
        toolbar: (props) => <CalendarTitle {...props} renderAfter={handleRenderToolbarAfter} />,
        timeSlotWrapper: (props) => (
          <FindTutorCalendarViewTimeSlot
            {...props}
            slots={classBanner.available_slots}
            selectedSlot={selectedSlot}
            setSelectedSlot={setSelectedSlot}
          />
        ),
        header: WeekDaysHeader,
      }}
      timeslots={1}
      step={60}
    />
  )
}

export default FindTutorCalendarView
